import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Td } from 'react-super-responsive-table';
import {
    renderStatusBadge,
    determineLeakRateIcon,
    getFileIcon,
    convertDateTime,
    workOrderDeleted,
    getRenderValue,
} from '../utils';
import { trakrefFontFamilyBold } from '../../../../utils'
import { Grey3 } from '../../../../color_utils';
import LeakRateExceeded from '../../../../Icons/ic_epaLeakRateExceeded.svg';
import { IconButton, Tooltip } from '@mui/material';
import { trakrefBlue } from '../../../../color_utils';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import UserInfo from '../../../../UserInfo';
import useTabs from '../../../../context/CustomTab/useTabs';
import Checkbox from '@mui/material/Checkbox';
import '../Table.css';

const RowFieldDisplay = ({
    column,
    row,
    rows,
    checkedRows,
    addCheckedRows,
    removeCheckedRows,
    index,
    showSelectColumnsList
}) => {
    const statusProperty = row[column.props.statusProperty];
    const itemIsClosed = statusProperty && statusProperty.toLowerCase() === 'closed';
    const { activeTab } = useTabs();
    const {
        property,
        disableLink,
        isVisible,
        externalLink,
        showLeakRateIcon,
        hover,
        link,
        type,
        externalLinkProperty,
        icon,
        showStatus,
        wrap,
        linkId,
        linksuffix,
        deletedProperty,
        isWorkOrder,
        canViewLink,
        noRedirect,
        onClick,
        underlink,
        filterTableOnNavigate,
        titleToFilter,
        propertyToFilter,
        typeToFilter,
        isClickable,
        onClickLink,
        callbackLink,
        MUIIcon,
        toolTip,
        isCheckBox,
        width,
        isSAFstatus,
        changeOutData,
        render,
        isLinkClickable,
        children,
    } = column.props;

    const getColumn = (property) => {
        const foundColumn = showSelectColumnsList.find(f => f.property === property);
        // if column cannot be found, do not show the column
        if ([undefined, null].includes(foundColumn)) {
            return {};
        }
        return foundColumn;
    };

    const getClassName = () => {
        const selectedProperty = showSelectColumnsList.find(f => f.property === property);
    
        if (selectedProperty && 'visible' in selectedProperty) {
            return selectedProperty.visible === false ? ' hideColumn' : '';
        }
    
        return '';
    };
    

    const linkDisabled = disableLink ? disableLink(row) : true;
    const isIconVisible = isVisible ? isVisible(row) : true;
    const fromPathName = activeTab ? window.location.pathname + `#${activeTab}` : window.location.pathname;

    if (render) {
        if (wrap) {
            return (
                <Td className={((getColumn(property)).visible === false ? ' hideColumn' : 'wrap-render')}>
                   {render(row)}
                </Td>
            );
        }
        return (
            <Td className={getClassName()}>
                {render(row)}
            </Td>
        );
    }

    if (externalLink) {
        return (
            <Td
                className={getClassName()}
            >
                <a href={row[property]} target="_blank">
                    {externalLink}
                </a>
            </Td>
        );
    } else if (property === "epaAnnualizedLeakRate" && showLeakRateIcon) {
        const epaAnnualizedLeakRate = row[property];
        const assetTypeId = row["assetTypeId"];
        if (determineLeakRateIcon(epaAnnualizedLeakRate, assetTypeId)) {
            return (
                <Td
                    className={((getColumn(property)).visible == false ? ' hideColumn' : '')}
                    title={hover}
                >
                    <img
                        src={LeakRateExceeded}
                        alt="file icon"
                        width="25"
                        height="25"
                        viewBox="0 0 20 18"
                        className="file-icon"
                    />
                </Td>
            );
        }
        return <Td />;
    } else if (property && !link) {
        const renderValue = getRenderValue(type, row[property]);
        // used to link an address to google maps
        if (externalLinkProperty) {
            const mapLink = row[externalLinkProperty];
            return (
                <Td className={getClassName()}>
                    {renderValue && (
                        <IconButton
                            sx={{ color: trakrefBlue }}
                            onClick={() => window.open(mapLink, "_blank")}
                        >
                            <MapOutlinedIcon />
                        </IconButton>
                    )}
                    {renderValue}
                </Td>
            );
        }
        if (wrap) {
            return (
                <Td
                    className={((getColumn(property)).visible === false ? ' hideColumn' : 'wrap')}
                    title={type === 'dateTime' ? convertDateTime(row[property]) : row[property]}
                >
                    <span
                        tabindex={row[property] == null ? "" : "0"}
                    >
                        {renderValue}
                    </span>
                </Td>
            );
        }
        return (
            <Td
                className={((getColumn(property)).visible === false ? ' hideColumn' : '')}
                title={type === 'dateTime' ? convertDateTime(row[property]) : row[property]}
            >
                <span
                    tabindex={row[property] == null ? "" : "0"}
                >
                    {renderValue}
                </span>
            </Td>
        );
    } else if (link) {
        if (icon) {
            if (itemIsClosed) {
                return (
                    <Td className={getClassName()} />
                )
            }

            if (!linkDisabled) {
                return (
                    <Td className={getClassName()}>
                        <Link title={hover}>
                            <img
                                src={icon}
                                width="20"
                                height="18"
                                viewBox="0 0 20 18"
                                className="table-svg"
                                alt="link icon"
                            />
                        </Link>
                    </Td>
                )
            }

            return (
                <Td className={getClassName()}>
                    <Link
                        title={hover}
                        to={(link == null ? "" : link) + (linkId == null ? "" : row[linkId]) + (linksuffix == null ? "" : linksuffix)}
                    >
                        <img
                            src={icon}
                            width="20"
                            height="18"
                            viewBox="0 0 20 18"
                            className="table-svg"
                            alt="link icon"
                        />
                    </Link>
                </Td>
            );
        } else if (showStatus) {
            let isDeleted = false;
            try {
                isDeleted = row[deletedProperty].toUpperCase() === 'YES'
            } catch { }

            if (isWorkOrder && UserInfo.isSystemAdministrator() && row[deletedProperty].toUpperCase() === 'YES') {
                return (
                    <Td className={getClassName()}>
                        {isDeleted === true ? renderStatusBadge('deleted') : renderStatusBadge(statusProperty)}
                        <Link
                            title={row[property]}
                            to={{
                                pathname: workOrderDeleted(column, row, link + row[linkId]),
                                state: {
                                    from: fromPathName
                                }
                            }}
                        >
                            {row[property]}
                        </Link>
                    </Td>
                );
            } else if (isWorkOrder !== true || (isWorkOrder === true && row[deletedProperty].toUpperCase() !== 'YES')) {
                if (statusProperty.toLowerCase() === 'deleted' && !canViewLink) {
                    return (
                        <Td  className={getClassName()}>
                            {renderStatusBadge(statusProperty)}
                            {row[property]}
                        </Td>
                    );
                }
                return (
                    <Td className={getClassName()}>
                        {renderStatusBadge(statusProperty)}
                        <Link
                            title={row[property]}
                            to={{
                                pathname: link + row[linkId],
                                state: {
                                    from: fromPathName
                                }
                            }}
                            className='link'
                        >
                            {row[property]}
                        </Link>
                    </Td>
                );
            }
            return (
                <Td className={getClassName()}>
                    {isDeleted === true ? renderStatusBadge('deleted') : renderStatusBadge(statusProperty)}

                    {row[property]}

                </Td>
            );

        } else if (isLinkClickable && !isLinkClickable(row)) {
            return (
                <Td className={getClassName()}>
                    <span
                        tabindex={row[property] == null ? "" : "0"}
                    >
                        {row[property]}
                    </span>
                </Td>
            );
        } else {
            if (noRedirect) {
                return (
                    <Td className={getClassName()}>
                        {row.fileName !== undefined && (
                            <img
                                src={getFileIcon(row.fileName)}
                                alt="file icon"
                                width="20"
                                height="20"
                                viewBox="0 0 20 18"
                                className="file-icon"
                            />
                        )}
                        <Link title={hover} onClick={() => onClick(rows[index])}>
                            {row[property]}
                        </Link>
                    </Td>
                );
            }
            if (!linkDisabled) {
                return (
                    <Td className={getClassName()}>
                        {row[property]}
                    </Td>
                )
            }
            if (underlink) {
                return (
                    <Td className={getClassName()}>
                        <Link
                            title={row[property]}
                            to={{
                                pathname: link + row[linkId],
                                state: {
                                    from: fromPathName
                                }
                            }}
                            className='underlink'
                        >

                            {row[property]}
                        </Link>
                    </Td>
                );
            }
            if (filterTableOnNavigate) {
                return (
                    <Td className={getClassName()}>
                        <Link
                            title={row[property]}
                            to={{
                                pathname: link,
                                state: {
                                    from: fromPathName,
                                    titleToFilter,
                                    propertyToFilter,
                                    typeToFilter,
                                    valueToFilter: row[propertyToFilter]
                                }
                            }}
                            className='link'
                        >
                            {row[property]}
                        </Link>
                    </Td>
                )
            }
            return (
                <Td className={getClassName()}>
                    <Link
                        title={row[property]}
                        to={{
                            pathname: link + row[linkId],
                            state: {
                                from: fromPathName
                            }
                        }}
                        className='link'
                    >
                        {row[property]}
                    </Link>
                </Td>
            );
        }
    } else if (isClickable) {
        if (itemIsClosed) {
            return (
                <Td className={getClassName()} />
            )
        }

        return (
            <Td className={getClassName()}>
                {linkDisabled && (
                    <Link
                        title={hover}
                        onClick={e => onClickLink(e, row)}
                    >
                        <img
                            src={icon}
                            width="20"
                            height="18"
                            viewBox="0 0 20 18"
                            className="table-svg"
                            alt="action"
                        />
                    </Link>
                )}
            </Td>
        );
    } else if (callbackLink) {
        if (icon) {
            return (
                <Td className={getClassName()}>
                    <Link
                        title={hover}
                        onClick={() => callbackLink(row[linkId])}
                    >
                        <img
                            src={icon}
                            width="20"
                            height="18"
                            viewBox="0 0 20 18"
                            className="table-svg"
                            alt="Icon"
                        />
                    </Link>
                </Td>
            );
        }
        else {
            return (
                <Td className={getClassName()}>
                    <Link
                        title={row[property]}
                        onClick={() => callbackLink(row[linkId])}
                    >
                    </Link>
                </Td>
            );
        }
    } else if (MUIIcon) {
        if (itemIsClosed) {
            return (
                <Td className={getClassName()} />
            )
        }
        return (
            <Td
                className={`${isIconVisible ? 'MUI-icon' : ''}`}
                onClick={(e) => isIconVisible && onClick(e, rows[index])}
            >
                {isIconVisible
                    ? (
                        toolTip ? (
                            <Tooltip
                                title={toolTip}
                            >
                                {children}
                            </Tooltip>
                        ) : children
                    ) : null
                }
            </Td>
        );
    } else if (isCheckBox) {
        return (
            <Td className={getClassName()}>
                <div style={{ width: width }}>
                    <Checkbox
                        style={{ padding: 0, marginLeft: 39 }}
                        sx={{
                            color: trakrefBlue,
                            "& .MuiSvgIcon-root": {
                                fontSize: 30
                            },
                            '&.Mui-checked': {
                                color: trakrefBlue,
                            },
                            '& .MuiSvgIcon-root': {
                                fontSize: 30,
                                color: trakrefBlue,
                            },
                        }}
                        onClick={() => {
                            if (checkedRows.some(r => r.id === rows[index].id)) {
                                removeCheckedRows(rows[index])
                            } else {
                                addCheckedRows(rows[index])
                            }
                        }}
                        checked={checkedRows.some(r => r.id === rows[index].id)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                </div>
            </Td>
        );
    } else if (isSAFstatus) {
        // check if changeOutData contain this column
        var containChangeOut = changeOutData.some((item) => item.id === rows[index].id);
        var statusClass = containChangeOut ? "statusChangeOut" : "statusPending";
        var text = containChangeOut ? "CHANGED OUT" : "PENDING";

        return (
            <Td className={getClassName()}>
                <div style={{ width: '120px' }}>
                    <div className={statusClass}>
                        <span style={{
                            color: containChangeOut ? trakrefBlue : Grey3,
                            fontFamily: trakrefFontFamilyBold,
                            fontSize: "12px",
                        }}>
                            {text}
                        </span>
                    </div>
                </div>
            </Td>
        );

    } else {
        return (
            <Td className={getClassName()}>
                {children}
            </Td>
        );
    }
};

RowFieldDisplay.propTypes = {
    row: PropTypes.node.isRequired,
    rows: PropTypes.node.isRequired,
    checkedRows: PropTypes.array.isRequired,
    index: PropTypes.node.isRequired,
    column: PropTypes.node.isRequired,
    showSelectColumnsList: PropTypes.node.isRequired,
};

RowFieldDisplay.defaultProps = {
    render: () => {}
};

export default RowFieldDisplay;
